<div class="ModalPassengersPriorityCode">
  <div class="ModalPassengersPriorityCode-close">
    <img alt="" src="../../../../assets/images/close.svg" (click)="onClose()" />
  </div>
  <div class="ModalPassengersPriorityCode-container">
    <span class="fs-41px lh-52px fw-medium-x text-center" [innerHTML]="'ModalPassengersPriorityCode.title' | translate"></span>
    <p class="fs-22px lh-30px fw-regular text-center">
      {{ 'ModalPassengersPriorityCode.subtitle' | translate }}
    </p>
    <div class="ModalPassengersPriorityCode-navContainer">
      <form class="ModalPassengersPriorityCode-content" [formGroup]="optionsForm">
        <button
          class="ModalPassengersPriorityCode-navButton fs-22px lh-30px fw-medium-x"
          [ngClass]="{ 'active': activeTab === 'upgrade' }"
          type="radio"
          formControlName='option'
          value='upgrade'
          (click)="setActive('upgrade')"
        >
          {{ 'ModalPassengersPriorityCode.upgradeList' | translate }}
        </button>
        <button
          class="ModalPassengersPriorityCode-navButton fs-22px lh-30px fw-medium-x"
          [ngClass]="{ 'active': activeTab === 'standby' }"
          type="radio"
          formControlName='option'
          value='standby'
          (click)="setActive('standby')"
        >
          {{ 'ModalPassengersPriorityCode.standbyList' | translate }}
        </button>
      </form>
    </div>
    <!-- List Component -->
     <am-passenger-list-priority-code *ngIf="standByList?.length > 0 || upgradeList?.length > 0"
      [type]="activeTab"
      [standByList]="standByList"
      [upgradeList]="upgradeList"
     ></am-passenger-list-priority-code>
    <div class="ModalPassengersPriorityCode-foot">
      <span class="fs-18px lh-26px fw-regular">
        {{ 'ModalPassengersPriorityCode.consultApp' | translate }}
      </span>
      <button class="ModalPassengersPriorityCode-footButton fs-18px lh-28px fw-medium-x" (click)="handleModalApp()">
        {{ 'ModalPassengersPriorityCode.downloadApp' | translate }}
      </button>
    </div>

    <app-am-loading [typeLoading]="'COMPONENT_LOADING'" *ngIf="loadingStatusPassenger"></app-am-loading>
  </div>
</div>
